import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { NumberInput } from '../NumberInput';
export const ControlledNumberInput = forwardRef(({ name, onAfterChange, ...props }, ref) => {
    const { control } = useFormContext();
    return (_jsx(Controller, { control: control, name: name, render: ({ field: { value, onChange: valueChange } }) => {
            return (_jsx(NumberInput, { ref: ref, ...props, value: value ?? '', onValueChange: (values) => {
                    valueChange(values.floatValue ?? null);
                    onAfterChange?.(values.floatValue ?? null);
                } }));
        } }));
});
